module.exports = __webpack_public_path__ + "assets/img/payment-banned.a4331e01.png";